import { render, staticRenderFns } from "./DuplicateMenuModal.vue?vue&type=template&id=05f0b043&scoped=true&"
import script from "./DuplicateMenuModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicateMenuModal.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateMenuModal.vue?vue&type=style&index=0&id=05f0b043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0b043",
  null
  
)

export default component.exports